import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { CancelamentoInscricaoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/cancelamento-inscricao/cancelamento-inscricao.service';
import type { CancelamentoInscricaoRequest, CancelamentoInscricaoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/cancelamento-inscricao/cancelamento-inscricao.model';

@Injectable({ providedIn: 'root' })
export class CancelamentoInscricaoServicosService {
    constructor(private api: CancelamentoInscricaoService) {}

    consultar(params: CancelamentoInscricaoRequest, context?: HttpContext): Observable<CancelamentoInscricaoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    efetivarSolicitacao(dto: CancelamentoInscricaoResponse, context?: HttpContext): Observable<void> {
        if (!dto?.numeroProtocolo || !dto?.anoProtocolo || !dto?.ufCrmOrigem) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrmOrigem são obrigatórios para efetivar.'));
        }

        return this.api.efetivarSolicitacao(dto, context);
    }
}
